module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#sports",
      toString: function () {
        return this.url;
      }
    }